import { Link } from "react-router-dom";
import {
  faBars,
  faRedoAlt,
  faArrowLeft,
  faBell,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";
import { setUserInfo } from "../../utils/UserInfo";
import HomeIcon from "@material-ui/icons/Home";
import { useSelector } from "react-redux";

const NavBar = (props) => {
  const navigations = useSelector((state) => state.navigations);

  const history = useHistory();

  const logout = () => {
    setUserInfo({});
    window.localStorage.removeItem("dashHistory");
    history.push("/admin/login");
  };

  return (
    <>
      <div
        style={{
          height: "70px",
          width: "100%",
          padding: "0",
          backgroundColor: "#ededed",
          border: "1px solid #d9dee4",
          position: "fixed",
          top: "0",
          zIndex: "20",
        }}
      >
        <div
          onClick={props.sideBarCollapse}
          style={{
            float: "right",
            width: "50px",
            height: "50px",
            cursor: "pointer",
            paddingRight: "12px",
            paddingLeft: "12px",
          }}
        >
          <FontAwesomeIcon
            style={{
              fontSize: "24px",
              position: "absolute",
              top: "50%",
              transform: "translateY(-50%)",
            }}
            className="text-light"
            icon={faBars}
          />
        </div>

        <div className="nav-items">
          <div
            onClick={() => {
              logout();
            }}
            style={{
              float: "right",
              height: "50px",
              cursor: "pointer",
              paddingLeft: "12px",
            }}
          >
            <span
              style={{ color: "#333333", lineHeight: "70px", fontSize: "14px" }}
            >
              خروج
            </span>
          </div>
        </div>

        <div
          onClick={() => {
            history.goBack();
          }}
          style={{
            // float: "left",
            width: "50px",
            height: "50px",
            cursor: "pointer",
            position: "fixed",
            top: "24px",
            left: "0",
            zIndex: "20",
          }}
          className="px-2"
        >
          <FontAwesomeIcon
            style={{
              fontSize: "28px",
              // position: "absolute",
              // top: "50%",
              // transform: "translateY(-50%)",
            }}
            className="text-light"
            icon={faArrowLeft}
          />
        </div>
        <div
          onClick={() => {
            window.location.reload();
          }}
          style={{
            width: "50px",
            height: "50px",
            cursor: "pointer",
            position: "fixed",
            top: "24px",
            left: "56px",
            zIndex: "20",
          }}
          className="px-2"
        >
          <FontAwesomeIcon
            style={{
              fontSize: "24px",
              // position: "absolute",
              // top: "50%",
              // transform: "translateY(-50%)",
            }}
            className="text-light"
            icon={faRedoAlt}
          />
        </div>
      </div>
      <div
        style={{
          height: "36px",
          width: "100%",
          paddingRight: "36px",
          backgroundColor: "#ededed",
          border: "1px solid #d9dee4",
          position: "fixed",
          top: "70px",
          zIndex: "20",
        }}
      >
        {/* <div> */}
        <>
          <div
            style={{
              float: "right",
              cursor: "pointer",
              paddingLeft: "12px",
              position: "relative",
              marginLeft: "8px",
            }}
          >
            {/* <span
              style={{ color: "#333333", lineHeight: "36px", fontSize: "14px" }}
            >
              خروج
            </span> */}
            <Link to={"/admin"}>
              <HomeIcon
                style={{
                  color: "#333333",
                  lineHeight: "36px",
                  fontSize: "28px",
                  marginTop: "4px",
                }}
              />
            </Link>
            <span
              style={{
                color: "#333333",
                fontSize: "28px",
                position: "absolute",
                left: "0",
              }}
            >
              /
            </span>
          </div>
        </>
        {/* </div> */}
        {navigations.map((navigation, idx) => {
          let path;
          if (navigation.path === "#") {
            path = navigation.id;
          } else {
            path = navigation.path;
          }
          // console.log(navigation);
          // console.log("path: ", path);
          return (
            <>
              <div
                style={{
                  float: "right",
                  cursor: "pointer",
                  paddingLeft: "20px",
                  position: "relative",
                  marginLeft: "8px",
                }}
              >
                <Link to={path} style={{ textDecoration: "none" }}>
                  <span
                    style={{
                      color: "#333333",
                      lineHeight: "36px",
                      fontSize: "14px",
                    }}
                  >
                    {navigation.name}
                  </span>
                </Link>
                <span
                  style={{
                    color: "#333333",
                    fontSize: "28px",
                    position: "absolute",
                    left: "0",
                  }}
                >
                  /
                </span>
              </div>
            </>
          );
        })}
      </div>
    </>
  );
};

export default NavBar;
